import { connect } from "react-redux";
import { showError, showSuccess } from "actions/notification";
import { deleteUser, getSignedUpUser } from "actions/user";
import { replace } from "connected-react-router";

import Translate from "utils/translate";

import Cancel from "./Cancel";

const { t } = new Translate("SignUp");

const mapDispatchToProps = (dispatch) => ({
  getUser: ({ email, invite_token }) => dispatch(getSignedUpUser(email, invite_token)), // eslint-disable-line
  destroyUser: (user) =>
    dispatch(deleteUser(user)).then(() =>
      dispatch(showSuccess(t("cancel.success.title"), t("cancel.success.body")))
    ),
  redirect: () => {
    dispatch(replace("/"));

    return dispatch(showError(t("cancel.error.title"), t("cancel.error.body")));
  },
});

export default connect(null, mapDispatchToProps)(Cancel);
